// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

export enum DnaSyngoviaScoreSeverityEtype {
  LOW = 'low',
  MEDIUM = 'medium',
  HIGH = 'high',
}
